import { addBlank, CODE_MASTER } from "../default-constants";

export const LABELS = {
  APPLICATION_NO: "申請番号",
  APPLICATION_DATE: "申請日",
  COMPANY_NAME: "事業者名",
  COMPANY_NAME_APPLICATION: "事業者名（申請書）",
  COMPANY_NAME_NATIONAL_TAX_ADMIN_AGENCY: "事業者名（国税庁）",
  CORPORATE_NUMBER: "法人番号",
  INDUSTRY: "業態",
  REP_NAME: "代表者名",
  MERCHANT_NAME: "加盟店名",
  REP_NAME_KANA_APPLICATION: "代表者名カナ（申請書）",
  REP_NAME_KANA_TSR: "代表者名カナ（TSR）",
  APPLICATION_POSTAL_CODE: "事業者住所郵便番号",
  APPLICATION_ADDRESS: "事業者住所",
  COMPANY_NAME_KANA_NATIONAL_TAX_ADMIN_AGENCY: "事業者名カナ（国税庁）",
  COMPANY_NAME_KANA_APPLICATION: "事業者名カナ（申請書）",
  MERCHANT: "加盟店",
  MERCHANT_TYPE: "加盟店種別",
  APPLICANT_USER_TYPE: "申請者種別",
  APPLICANT_EMAIL: "申請者メールアドレス",
  INDIVIDUAL_HANDLING_REASON: "個別取扱事由",
  CONFIRMATION_RESULT: "確認結果",
  CONFIRMATION_ADDRESS_TITLE: "登録する事業者住所を選択してください",
  COMMENT: "コメント",
  RATE_CATEGORY_PLANNED: "料率カテゴリ（連携予定）",
  RATE_CATEGORY_LINKED: "料率カテゴリ（連携済み）",
  INDIVIDUAL_CONSULTATION_NO: "個別相談-No",
  INDIVIDUAL_CONSULTATION_BRANCH_NO: "個別相談-枝番",
  STORE: "店舗",
  BULK_CONFIRMATION_RESULT_OK: "一括確認結果OK",
  BULK_CONFIRMATION_RESULT_NG: "一括確認結果NG",
  STORE_NAME: "店舗名",
  SELECT: "選択",
  COMPANY_URL: "事業者URL",
  ITEM_SCREEN_DISPLAY_PRESENCE_ABSENCE: "明細詳細反映有無",
  RELATED_APPLICATION_INFORMATION_APPLICATION_NO: "関連申請情報（申請番号）",
  TSR_NAME: "TSR情報",
  TAX_NAME: "国税庁情報",
  MERCHANT_APPLICATION_NAME: "加盟店申請情報",
  RETURN_DUE_DEFICIENCIES: "差戻不備ありで返却",
  UPDATE_TSR_BUTTON_NAME: "TSR情報で更新",
  UPDATE_TAX_BUTTON_NAME: "国税庁情報で更新",
  UPDATE_MERCHANT_BUTTON_NAME: "加盟店申請情報で更新",
  UPDATE_NG_BUTTON_NAME: "NG",
  SLASH: "　/　",
  BLANK_LITTLE_LONG: "　　　　　　　　　　　　　　　　　　　",
  BLANK_MIDDLE_LONG: "　　　　　　　　　　　　　　　　　　　　　　　　　　　",
  BLANK_RATE_CATEGORY: "　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　",
  BLANK_SUPER_ADDRESS_LONG:
    "　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　",
  BLANK_LONG:
    "　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　",
  BLANK_SUPER_LONG:
    "　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　",
} as const;

export const COMMENT_MAX_LENGTH = 100;
export const DEFAULT_COMMENT = "総合的判断により、見送りとさせていただきます。";
export const REQUIRED_INDIVIDUAL_COUNSELING_PROJECT_CONFIRMATION = "01"; // 要個別相談案件確認
export const REQUIRED_TOURIST_INDUSTRY_LICENSES_CONFIRMATION = "02"; // 要旅行業免許確認
export const REQUIRED_BEDS_NUMBER_CONFIRMATION = "03"; // 要病床数確認
export const REQUIRED_INDUSTRY_DETAIL_CONFIRMATION = "04"; // 要業態内容確認
export const REQUIRED_REPRESENTATIVE_CONFIRMATION = "05"; // 要代表者確認
export const CORPORATE_NUMBER_MISMATCH_HAS_EXISTING = "06"; // 法人番号相違（既存あり）
export const CORPORATE_NUMBER_MISMATCH_NO_EXISTING = "07"; // 法人番号相違（既存なし）
export const CHANGE_APPLICATION_CONFIRMATION = "08"; // 変更申請確認確認
export const REIMBURSEMENT_CHARGE_RATE_CATEGORY = "09"; // 精算料率カテゴリ確認
export const REQUIRES_ADDRESS_CONFIRMATION = "10"; // 事業者住所確認

// ステータス
export const CONFIRMATION_STATUS = CODE_MASTER["CONFIRMATION_STATUS"];
export const STATUS_CONFIRMING = CONFIRMATION_STATUS[0];
export const STATUS_CONFIRMED = CONFIRMATION_STATUS[1];

// 確認結果
export const CONFIRMATION_RESULT = addBlank(CODE_MASTER["CONFIRMATION_RESULT"]);
export const RESULT_OK = CONFIRMATION_RESULT[1];
export const RESULT_NG = CONFIRMATION_RESULT[2];

// 住所選択
const CONFIRMATION_ADDRESS = CODE_MASTER["CONFIRMATION_ADDRESS"];
export const ADDRESS_UNSELECTED = CONFIRMATION_ADDRESS[0];
export const ADDRESS_TSR = CONFIRMATION_ADDRESS[1];
export const ADDRESS_TAX = CONFIRMATION_ADDRESS[2];
export const ADDRESS_APP = CONFIRMATION_ADDRESS[3];
export const ADDRESS_NG = CONFIRMATION_ADDRESS[4];

export const CONFIRMATION_AVAILABILITY =
  CODE_MASTER["CONFIRMATION_AVAILABILITY"];
export const EXISTS = CONFIRMATION_AVAILABILITY[0];
export const NOT_EXIST = CONFIRMATION_AVAILABILITY[1];

export const INDIVIDUAL_COUNSELING_PROJECT: string[] = [
  REQUIRED_INDIVIDUAL_COUNSELING_PROJECT_CONFIRMATION,
  REQUIRED_TOURIST_INDUSTRY_LICENSES_CONFIRMATION,
  REQUIRED_BEDS_NUMBER_CONFIRMATION,
  REQUIRED_INDUSTRY_DETAIL_CONFIRMATION,
  REIMBURSEMENT_CHARGE_RATE_CATEGORY,
];
